import {
  TableContainer,
  TableRow,
} from "@/components/report/disease_risk/disease_risk_v1/medical_facility_report/commons";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  Typography,
} from "@mui/material";
import {
  ReportDailyResultImg,
  RiskType,
  ThreeLevelScalesType,
} from "../commons";

export const SLEEP_JUDGE_TITLE_LIST = [
  "良好",
  "注意",
  "警戒",
  "判定不能",
] as const;
export type SleepJudgeTitle = (typeof SLEEP_JUDGE_TITLE_LIST)[number];
export const SLEEP_JUDGE_TITLE_CONFIG: Record<SleepJudgeTitle, RiskType> = {
  良好: "good",
  注意: "caution",
  警戒: "alert",
  判定不能: "unknown",
} as const;

export interface DailyJudgeTableProps {
  data: (ThreeLevelScalesType | null)[];
}
export function DailyJudgeTable({ data }: DailyJudgeTableProps) {
  return (
    <TableContainer
      sx={{
        borderRadius: "0",
        border: "solid 1px #D8D7D6",
        "& tr td": {
          py: 4,
          px: 0,
          border: "none",
        },
        "& tr th": {
          p: "8px 0",
          "& .MuiTypography-caption": {
            display: "block",
            textAlign: "center",
          },
          "&:not(:first-of-type)": {
            "& .MuiTypography-caption": {
              borderLeft: "solid 1px #D8D7D6",
            },
          },
        },
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {data.map((_, i) => (
              <TableCell key={i}>
                <Typography variant="caption">{i + 1}日目</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {data.map((d, i) => (
              <TableCell key={i} sx={{ textAlign: "center" }}>
                {d != null ? (
                  <ReportDailyResultImg
                    type={d}
                    style={{ margin: "auto", display: "block" }}
                  />
                ) : (
                  <Typography fontWeight={400} fontSize="13px">
                    -
                  </Typography>
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
